import React, { memo, useMemo, useState } from "react";
import { TableRow, TableCell } from "@material-ui/core";
// component
import MyModal from "components/MyModal";
import AlertDialog from "components/Dialog";
import Action from "components/ActionPopOver";
import { formatDate, numberFormat } from "helper";
import { MyCheckbox } from "components/MyCheckbox";
// direct import
import { displayStatus } from "./helper";
import TributeInformation from "./TributeInfo";

const TributeTableData = (props) => {
  const {
    row,
    onReversalClick,
    formik,
    setEditTribute,
    setEditTributeData,
    setTributeAdd,
    setViewClick,
    viewClick,
    setTributeList,
    openSendLetterModal,
    refetchExport,
    handleRowClick,
    checkAll,
    setCheck,
    check,
  } = props;
  const [editData, setEditData] = useState("");
  const [editAction, setEditAction] = useState("");
  const [confirmClose, setConfirmClose] = useState(false);
  const [openAttributeInfo, setOpenAttributeInfo] = useState(false);
  const [reversalActionTypes, setReversalActionTypes] = useState(false);

  const handleCloseDialog = () => setReversalActionTypes(false);

  const resetTributeFields = () => {
    formik.setFieldValue("tribute_type", "");
    formik.setFieldValue("donor_name", "");
    formik.setFieldValue("note", "");

    formik.setFieldValue("showAcknowledgement", false);
    formik.setFieldValue("acknowledgements", [
      {
        recipient_name: "",
        email: "",
        tribute_address: "",
      },
    ]);
  };

  const onEditClick = (row) => {
    setOpenAttributeInfo(true);
    setEditTribute(true);
    setEditData(row);
    setEditTributeData(row);
    setEditAction("edit_tribute");
    setViewClick(false);
  };
  const onViewClick = (row) => {
    setOpenAttributeInfo(true);
    setEditTributeData(row);
    setViewClick(true);
  };

  const addAttributeHandler = () => {
    resetTributeFields();
    setOpenAttributeInfo(true);
    setViewClick(false);
    setEditAction("add_tribute");
    setEditTributeData({
      tribute_info: {
        tribute_type: "",
        donor_name: "",
        note: "",
        showAcknowledgement: false,
        acknowledgements: [
          {
            recipient_name: "",
            email: "",
            tribute_address: "",
          },
        ],
      },
    });
  };

  const hasTribute = useMemo(
    () => row?.tribute_info?.type,
    [row?.tribute_info?.type]
  );

  const closeModal = () => {
    if (viewClick) return confirmCloseHandler();
    setConfirmClose(true);
  };
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setEditAction("");
    if (editAction === "add_tribute") {
    }
    setOpenAttributeInfo(false);
  };

  return (
    <React.Fragment>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        style={{ cursor: "pointer" }}
        onClick={() => handleRowClick(row)}
      >
        <TableCell>
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              color: "#4F4F4F",
              fontSize: "14px",
              opacity: checkAll ? 0.5 : 1,
              marginLeft: 5,
            }}
          >
            <MyCheckbox
              handlechange={(e) => {
                e.stopPropagation();

                if (checkAll) return;
                const checked = e.target.checked;
                if (checked) {
                  setCheck((prev) => [...prev, row]);
                } else {
                  setCheck((prev) =>
                    prev.filter((item) => item?._id !== row?._id)
                  );
                }
              }}
              checked={
                checkAll ||
                check?.findIndex((item) => item?._id === row?._id) !== -1
              }
              disabled={checkAll}
            />
          </div>
        </TableCell>
        <TableCell className="donor-name" component="th" scope="row">
          <div className="transaction-account-name ">
            {row?.tribute_info?.donorName || row?.Account?.name || "-"}
          </div>
        </TableCell>
        <TableCell className="donor-name" component="th" scope="row">
          <div className=" ">{row?.tribute_info.type || "-"}</div>
        </TableCell>
        <TableCell className="donor-name" component="th" scope="row">
          <div className=" ">{row?.tribute_info?.name || "-"}</div>
        </TableCell>
        <TableCell className="donor-date">
          <div className="transaction-led-sub table-row">
            <p className="sub">
              {formatDate({ date: row?.date, formatType: "defaultWithUTC" })}
            </p>
          </div>
        </TableCell>
        <TableCell className="donor-name" component="th" scope="row">
          <div className=" ">
            {row?.SubLedger?.name || row?.Ledger?.name || "-"}
          </div>
        </TableCell>
        <TableCell className="donor-amount" align="left">
          <div className="transaction-charged table-row">
            {numberFormat({
              number: +row?.total_amount,
              decimal: 2,
              style: "currency",
            })}
          </div>
        </TableCell>
        <TableCell className="donor-paper" align="left">
          <div className="table-row">
            <MyCheckbox checked={!!row?.tribute_info?.sendPaper} disabled />
          </div>
        </TableCell>
        <TableCell className="donor-sent" align="left">
          <div className="transaction-led-sub table-row">
            <span style={{ fontWeight: 500 }}>
              {displayStatus(row?.tribute_info?.status)}
            </span>
            {row?.tribute_info?.status === "sent" &&
              row?.tribute_info?.date && (
                <div className="led">
                  {formatDate({
                    date: row?.tribute_info?.date,
                    formatType: "defaultWithUTC",
                  })}
                </div>
              )}
          </div>
        </TableCell>

        <TableCell
          className="donor-action sticky-body-column"
          align="left"
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              cursor: "pointer",
              paddingleft: "0px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Action
              style={{ width: "16px" }}
              action="tribute"
              onEditClick={hasTribute ? () => onEditClick(row) : undefined}
              onViewClick={hasTribute ? () => onViewClick(row) : undefined}
              onAddClick={!hasTribute ? addAttributeHandler : undefined}
              onSendLetterClick={openSendLetterModal}
              row={row}
            />
          </div>
          <MyModal
            className="new-charge-modal"
            open={openAttributeInfo}
            onClose={closeModal}
          >
            <TributeInformation
              formik={formik}
              id={row?._id}
              editAction={editAction}
              editData={editData}
              setTributeAdd={setTributeAdd}
              setOpenAttributeInfo={setOpenAttributeInfo}
              viewClick={viewClick}
              setTributeList={setTributeList}
              refetchExport={refetchExport}
              closeModal={confirmCloseHandler}
            />
          </MyModal>
          <AlertDialog
            open={reversalActionTypes}
            getTypes={[]}
            handleClose={handleCloseDialog}
            closeButton={"Close"}
            onDecline={() => {
              setReversalActionTypes(false);
            }}
            onAccept={(id, type, hidden) =>
              onReversalClick(
                row?.charge?.status === "charge"
                  ? {
                      reversal_type: {
                        id: id,
                        type: type,
                        hidden: hidden,
                      },
                      chargeId: row.charge?._id,
                    }
                  : "",
                setReversalActionTypes
              )
            }
            content={"Choose a reversal type "}
          />
        </TableCell>
      </TableRow>
      <AlertDialog
        open={confirmClose}
        handleClose={() => setConfirmClose(false)}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={`Do you want to discard the changes you made?`}
      />
    </React.Fragment>
  );
};

export default memo(TributeTableData);
